// import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { WrapContexts } from "webgl-memory";
import { DEBUG_GPU_MEMORY } from "./lib/client";
import { Routes } from "./Routes";

if (DEBUG_GPU_MEMORY) {
    WrapContexts();
}

window.global ||= window;

const router = createBrowserRouter(Routes);

createRoot(document.getElementById("root")!).render(
    // <StrictMode>
    <RouterProvider router={router} future={{ v7_startTransition: true }} />
    // </StrictMode>
);
